import { render, staticRenderFns } from "./expertManage.vue?vue&type=template&id=0975cc00&scoped=true"
import script from "./expertManage.vue?vue&type=script&lang=js"
export * from "./expertManage.vue?vue&type=script&lang=js"
import style0 from "./expertManage.vue?vue&type=style&index=0&id=0975cc00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0975cc00",
  null
  
)

export default component.exports